import { render, staticRenderFns } from "./ShopBoxView.vue?vue&type=template&id=3854f4be&scoped=true"
import script from "./ShopBoxView.vue?vue&type=script&lang=js"
export * from "./ShopBoxView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3854f4be",
  null
  
)

export default component.exports